import { render, staticRenderFns } from "./AppHeader_Navs.vue?vue&type=template&id=a21c5584&scoped=true&"
import script from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
export * from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader_Navs.vue?vue&type=style&index=0&id=a21c5584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c5584",
  null
  
)

export default component.exports